(function () {
    'use strict';

    angular
        .module('home')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('home', {
                url: '/home',
                sticky: true,
                views: {
                    'homeView': {
                        templateUrl: 'home/views/home.tpl.html',
                        controller: 'HomeCtrl',
                        controllerAs: 'home'
                    }
                },
                onEnter: function(UserPrivilegesService){
                   UserPrivilegesService.setUserPrivilegeView("crew/menu");
                }
            });
    }
}());
